
const ServicesPreview = () => {
  const services = [
    {
      name: 'Panel Upgrade',
      description: 'Complete electrical panel replacement and upgrade to modern standards',
      price: 'Starting at $1,200',
      image: 'https://public.readdy.ai/ai/img_res/eae158fafb758fb4f07db488936bbf09.jpg'
    },
    {
      name: 'EV Charger Installation',
      description: 'Level 2 electric vehicle charging station installation for home and business',
      price: 'Starting at $800',
      image: 'https://readdy.ai/api/search-image?query=Electric%20vehicle%20charger%20installation%20on%20garage%20wall%2C%20clean%20modern%20setup%2C%20white%20background%2C%20professional%20electrical%20installation%2C%20Tesla%20charger%20style&width=400&height=300&seq=ev-charger&orientation=landscape'
    },
    {
      name: 'Potlight Installation',
      description: 'LED recessed lighting installation for modern home illumination',
      price: 'Starting at $150/light',
      image: 'https://readdy.ai/api/search-image?query=LED%20potlight%20recessed%20lighting%20installation%20in%20ceiling%2C%20modern%20home%20interior%2C%20clean%20white%20background%2C%20professional%20electrical%20work%2C%20bright%20even%20lighting&width=400&height=300&seq=potlights&orientation=landscape'
    },
    {
      name: 'Electrical Repairs',
      description: 'Professional electrical troubleshooting and repair services',
      price: 'Starting at $120',
      image: 'https://readdy.ai/api/search-image?query=Electrician%20performing%20electrical%20repairs%20with%20tools%20and%20equipment%2C%20clean%20workspace%2C%20professional%20safety%20gear%2C%20white%20background%2C%20detailed%20electrical%20work&width=400&height=300&seq=repairs&orientation=landscape'
    },
    {
      name: 'Outlet Installation',
      description: 'New electrical outlet and switch installation throughout your property',
      price: 'Starting at $80',
      image: 'https://readdy.ai/api/search-image?query=Modern%20electrical%20outlet%20installation%20in%20wall%2C%20clean%20white%20background%2C%20professional%20electrical%20work%2C%20new%20outlet%20and%20switch%20installation&width=400&height=300&seq=outlets&orientation=landscape'
    },
    {
      name: 'Wiring Services',
      description: 'Complete home and commercial electrical wiring solutions',
      price: 'Starting at $200',
      image: 'https://readdy.ai/api/search-image?query=Professional%20electrical%20wiring%20installation%2C%20clean%20organized%20cables%2C%20modern%20electrical%20work%2C%20white%20background%2C%20safety%20equipment%20visible&width=400&height=300&seq=wiring&orientation=landscape'
    },
    {
      name: 'Emergency Service',
      description: '24/7 emergency electrical repairs and troubleshooting',
      price: 'Starting at $150',
      image: 'https://readdy.ai/api/search-image?query=Emergency%20electrical%20service%20truck%20and%20equipment%2C%20professional%20electrician%20with%20tools%2C%20clean%20white%20background%2C%20urgent%20electrical%20repair%20setup&width=400&height=300&seq=emergency&orientation=landscape'
    },
    {
      name: 'Lighting Installation',
      description: 'Indoor and outdoor lighting design and installation services',
      price: 'Starting at $100',
      image: 'https://readdy.ai/api/search-image?query=Modern%20lighting%20installation%20in%20home%2C%20LED%20fixtures%20and%20professional%20electrical%20work%2C%20clean%20white%20background%2C%20bright%20illuminated%20space&width=400&height=300&seq=lighting&orientation=landscape'
    },
    {
      name: 'Circuit Breaker Service',
      description: 'Circuit breaker replacement and electrical panel maintenance',
      price: 'Starting at $180',
      image: 'https://readdy.ai/api/search-image?query=Circuit%20breaker%20installation%20and%20electrical%20panel%20service%2C%20professional%20electrical%20work%2C%20clean%20white%20background%2C%20modern%20electrical%20equipment&width=400&height=300&seq=breaker&orientation=landscape'
    },
    {
      name: 'Electrical Inspection',
      description: 'Comprehensive electrical safety inspection and code compliance',
      price: 'Starting at $250',
      image: 'https://readdy.ai/api/search-image?query=Electrical%20safety%20inspection%20with%20professional%20equipment%2C%20electrician%20checking%20electrical%20systems%2C%20clean%20white%20background%2C%20inspection%20tools%20visible&width=400&height=300&seq=inspection&orientation=landscape'
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Our <span className="text-yellow-600">Electrical Services</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Professional electrical solutions for residential and commercial properties in the GTA area.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-white border border-gray-200 rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow">
              <img
                src={service.image}
                alt={service.name}
                className="w-full h-48 object-cover object-top"
              />
              <div className="p-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-2">{service.name}</h3>
                <p className="text-gray-600 mb-4">{service.description}</p>
                <div className="flex justify-between items-center">
                  <span className="text-lg font-bold text-yellow-600">{service.price}</span>
                  <a
                    href={`https://wa.me/16472873597?text=Hi%20Volt%20Electric!%20I%20want%20to%20order%20${encodeURIComponent(service.name)}.`}
                    className="bg-yellow-400 text-black px-4 py-2 rounded-lg font-medium hover:bg-yellow-500 transition-colors cursor-pointer whitespace-nowrap inline-flex items-center space-x-2"
                  >
                    <i className="ri-whatsapp-fill"></i>
                    <span>Order Now</span>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesPreview;
